import { useCallback, useState, useEffect } from 'react'
import solicitacoesRepository from '../SolicitacoesRepository'

const useClassificacaoManager = ({ setMessage, solicitacaoId }) => {
  const [classificacao, setClassificacao] = useState()
  const [loading, setLoading] = useState(false)

  const loadClassificacao = useCallback(async () => {
    setLoading(true)
    const response = await solicitacoesRepository.getClassificacao(
      solicitacaoId
    )
    if (response.ok) {
      setClassificacao(response?.data)
    } else {
      setMessage(response?.data?.error?.message)
    }
    setLoading(false)
  }, [solicitacaoId])

  useEffect(() => {
    if (solicitacaoId) {
      loadClassificacao()
    }
  }, [solicitacaoId])

  return { classificacao, loadClassificacao, loading }
}

export default useClassificacaoManager
